import { http } from '../api/http';

export type WithdrawalContext = {
  wallet: {
    available: string;
    currency: string;
    updatedAt: string | null;
  };
  bankAccount:
      | {
        id: string;
        beneficiaryName?: string | null;
        bank?: { name: string | null; code: string | null } | null;
        currency?: string | null;
        accountType?: string | null;
        clabeMasked?: string | null;
        status?: string | null;
        isDefault?: boolean | null;
        hasBankAccount: true;
      }
    | {
        hasBankAccount: false;
      };
};

export type WithdrawalRequest = {
  id: string | number;
  status: string;
  requestedAt: string;
  amount: string;
  currency: string;
  approvedAt?: string | null;
  executedAt?: string | null;
  reference?: string | null;
  userComment?: string | null;
  notes?: string | null;
  message?: string;
};

export const WithdrawalsService = {
  getContext() {
    return http<WithdrawalContext>('/withdrawals/context');
  },

  create(payload: {
    amount: string;
    bankAccountId: string;
    mfaCode: string;
    userComment?: string;
  }) {
    return http<WithdrawalRequest>('/withdrawals', {
      method: 'POST',
      body: payload
    });
  },

  list() {
    return http<Array<{
      id: string | number;
      amount: string | number | { s?: number; e?: number; d?: number[] };
      currency: string;
      status: string;
      requested_at: string;
      approved_at?: string | null;
      executed_at?: string | null;
      reference?: string | null;
      user_comment?: string | null;
      notes?: string | null;
    }>>('/withdrawals');
  },

  sendMfaCode() {
    return http<{ message?: string }>('/auth/mfa/send-code', {
      method: 'POST',
      body: { purpose: 'WITHDRAWAL_REQUEST' }
    });
  }
};
